/* eslint-disable no-return-assign */
import React from 'react'
import { Typography, Card, CardMedia, CardContent } from '@material-ui/core'

import 'react-responsive-carousel/lib/styles/carousel.min.css'
import SlideshowItemStyles from './SlideshowItemStyles'
import { getImageFromFirebaseWithHook } from '../apps/helpers'

const SlideshowItem = ({ img, title, description }) => {
  const classes = SlideshowItemStyles()

  const [image, setImage] = React.useState(null)

  React.useEffect(() => {
    let isMounted = true

    if (img) {
      getImageFromFirebaseWithHook(img, (resolvedImage) => {
        if (isMounted) {
          setImage(resolvedImage)
        }
      })
    }

    return () => {
      isMounted = false
    }
  }, [img])

  return (
    <div className={classes.wrapper}>
      <Card className={classes.root} elevation={0}>
        <CardMedia
          className={classes.media}
          image={image}
          title={title || 'img'}
        />
        <CardContent className={classes.content}>
          <Typography className={classes.title} variant="h3">
            {title}
          </Typography>

          <Typography className={classes.description} variant="body1">
            {description}
          </Typography>
        </CardContent>
      </Card>
    </div>
  )
}

export default SlideshowItem
